import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { cancelParcelOptions } from './constants'

const CancelParcelSelector = ({ onChange, value, disabled }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Cancelar pedido asociado en plataforma de comercio electrónico')}
      menuItems={cancelParcelOptions.map(o => ({ ...o, label: t(o.label) }))}
      handleChange={e => onChange(e.target.value)}
      value={value}
      disabled={disabled}
      fullWidth
    />
  )
}

export default CancelParcelSelector
